import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ReactGA from 'react-ga';

export default function SignOut() {
  const navigate = useNavigate();

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);

    axios
      .post(process.env.REACT_APP_GD2_URL + '/portal_apis/clients/account/logout.json', {})
      .then(data => {
        localStorage.clear();
        navigate('/sign-in');
      })
      .catch(error => {
        console.error(JSON.stringify(error));

        if (error.response) {
          console.error(error.response);
        } else if (error.request) {
          console.error(error.request);
        } else {
          console.error(error.message);
        }
        localStorage.clear();
        navigate('/sign-in');
      });
  }, [navigate]);

  return <div className="page-header u-center-text content-above-footer">See you next time!</div>;
}
